/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { Button, message, Modal, Space, Spin, Switch, Table } from "antd";
import React, { useEffect, useState } from "react";

import { getSupaClient } from "../../lib/supabase";
import BotMessages from "../BotQuestions/BotQuestions";
import TriggerTemplate from "../TriggerTemplate/TriggerTemplate";

const modalStyle = { top: 40, right: 10 };

/**
 * Render Existing Trigger
 * @props selectTrigger callback for selecting any trigger to show its track
 */
const ExistingTrigger = (props) => {
  const supabase = getSupaClient();
  const [isTriggerEditVisible, setIsTriggerEditVisible] = useState(false);
  const [userSettings, setUserSettings] = useState({});
  const [currentTrigger, setCurrentTrigger] = useState(null);
  const [editorType, setEditorType] = useState("");
  const [teamTriggers, setTeamTriggers] = useState();
  const [loading, setLoading] = useState(true);
  const teamId = localStorage.getItem("team-id");

  /**
   * Load Existing Triggers
   */
  const loadTriggers = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("team_triggers")
      .select(
        "id, name, created_by (slack_id, name), trigger_invocations (id), trigger_config, config, type, active"
      )
      .filter("team", "eq", teamId)
      .filter("is_deleted", "eq", false)
      .order("id", { ascending: false });

    if (error) {
      message.error("Try again");
    }
    if (data) {
      setTeamTriggers(
        data.map((item) => {
          return {
            id: item.id,
            name: item.name,
            created_by: item.created_by?.name,
            config: item.config,
            trigger_config: item.trigger_config,
            type: item.type,
            active: item.active,
            members_enrolled: item.trigger_invocations
              ? item.trigger_invocations?.length
              : 0,
          };
        })
      );
    }
    setLoading(false);
  };

  useEffect(() => {
    loadTriggers();
  }, [props.refresh]);

  useEffect(() => {
    document.title = " Automation & Triggers | Dots";
  }, []);

  /**
   * Toggle visibility of trigger
   * @param {Object} trigger object of selected trigger
   */
  const changeTriggerVisibility = async (trigger) => {
    // console.log("trigger", trigger, teamTriggers);
    console.log("trigger current", trigger.id, trigger.active);
    const { data, error } = await supabase
      .from("team_triggers")
      .update({ active: !trigger.active })
      .match({ id: trigger.id });
    if (error) {
      message.error("Error updating");
    }
    if (data) {
      await loadTriggers();
      message.success("Successfully updated");
    }
  };

  /**
   * Open Edit Model and set trigger to current trigger
   * @param {Object} trigger object of selected trigger
   */
  const editTrigger = async (trigger) => {
    setCurrentTrigger(trigger);
    setIsTriggerEditVisible(true);
    const checkIsSurvey = async () => {
      const { data, error } = await supabase
        .from("saved_surveys")
        .select("survey_content")
        .filter("id", "eq", trigger.config[0].survey_id);
      return data;
    };
    if (trigger.config[0].onboarding_questions) {
      setEditorType("onboarding_questions");
    } else {
      const data = await checkIsSurvey();
      if (data) {
        if (data[0].survey_content.onboarding_questions) {
          const updatedTrigger = { ...trigger };
          updatedTrigger.config[0].onboarding_questions =
            data[0].survey_content.onboarding_questions;
          setCurrentTrigger(updatedTrigger);
          setEditorType("onboarding_questions");
        } else {
          setEditorType("messages");
        }
      } else {
        setEditorType("messages");
      }
    }
  };

  /**
   * Close Edit Modal
   */
  const closeEditModal = () => {
    setIsTriggerEditVisible(false);
    setCurrentTrigger(null);
  };

  /**
   * Delete selected trigger
   * @param {Object} trigger object of selected trigger
   */
  const deleteTrigger = async (trigger) => {
    const { data, error } = await supabase
      .from("team_triggers")
      .update({ is_deleted: true, active: false })
      .match({ team: teamId, id: trigger.id });
    if (error) {
      console.log("Error in deleteTrigger:", error);
      message.error("Error deleting");
    }
    if (data) {
      message.success("Successfully deleted");
    }
    loadTriggers();
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name - b.name,
      render: (name, trigger) => (
        <Space>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            defaultChecked
            checked={trigger.active}
            onChange={() => changeTriggerVisibility(trigger)}
          />
          <Button
            type="link"
            key={name}
            onClick={() => props.selectTrigger(trigger)}
          >
            {name}
          </Button>
        </Space>
      ),
    },
    {
      title: "Created By",
      dataIndex: "created_by",
      key: "created_by",
    },
    {
      title: "# of members enrolled",
      dataIndex: "members_enrolled",
      key: "members_enrolled",
      sorter: (a, b) => a.age - b.age,
    },
    {
      title: "Action",
      key: "action",
      render: (data, trigger) => (
        <Space size="large">
          <Button
            type="link"
            key={trigger.id}
            onClick={() => props.selectTrigger(trigger)}
          >
            Track
          </Button>
          <div style={{ display: "flex", alignItems: "center" }}>
            <EditOutlined />
            <Button
              type="link"
              key={trigger.id}
              onClick={() => editTrigger(trigger)}
            >
              Edit
            </Button>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <DeleteOutlined />
            <Button
              type="link"
              key={trigger.id}
              onClick={() => deleteTrigger(trigger)}
            >
              Delete
            </Button>
          </div>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Spin spinning={loading}>
        <Table columns={columns} dataSource={teamTriggers} />
      </Spin>
      <Modal
        width={1100}
        title="Edit trigger"
        style={modalStyle}
        visible={isTriggerEditVisible}
        onCancel={() => {
          closeEditModal();
          setEditorType("");
        }}
        footer={[]}
      >
        {currentTrigger && editorType === "onboarding_questions" ? (
          <BotMessages
            trigger={currentTrigger}
            type="edit"
            loadTriggers={loadTriggers}
            closeModal={closeEditModal}
          />
        ) : (
          <TriggerTemplate
            id={currentTrigger?.id}
            type="edit"
            trigger={currentTrigger}
            loadTriggers={loadTriggers}
            userSettings={userSettings}
            closeModal={closeEditModal}
          />
        )}
      </Modal>
    </>
  );
};

export default ExistingTrigger;
